export default "__VITE_ASSET__29f9cb0a__"